import Vue from 'vue'
import Vuei18n from 'vue-i18n'

Vue.use(Vuei18n)

export default new Vuei18n({
  locale: 'ru',
  silentTranslationWarn: true,
  messages: {
    en: {
      'Неверный код.': 'Invalid code',
      'Неверно введён логин или пароль.': 'Wrong login or password',
      'Авторизация Google': 'Google authorization',
      'Google Authenticator код': 'Google Authenticator code',
      'Введите код.': 'Enter code.',
      'назад': 'back',
      'Войти': 'Log in',
      'Логин': 'Login',
      'Введите логин.': 'Enter login',
      'Пароль': 'Password',
      'Пароль должен содержать не менее 6 символов.': 'Password must contain not less than 6 symbols.',
      'Я забыл :(': 'I forgot :(',
      'Для восстановления пароля введите ваш логин': 'Enter your login',
      'ВСПОМНИЛ!': 'I REMEMBERED!',
      'Сбросить': 'Reset',
      'Проверьте вашу почту — там инструкции по восстановлению пароля.': 'Check your email - there is an instruction for password recovery.',
      'Готово': 'Ok',
      'Ошибка сервера.': 'Server error.',
      'Регистрация запрещена.': 'Forbidden',
      'Регистрация': 'Registration',
      'Введите валидный email.': 'Enter valid email',
      'Телефон': 'Phone',
      'Неправильный формат телефона.': 'Invalid phone number',
      'Создать': 'Create',
      'Почти готово!': 'Almost ready',
      'На указанный Вами e-mail адрес выслано письмо с инструкциями по дальнейшей настройке Вашего аккаунта.': 'Check your email - there is an instruction how to log in to platfromcraft.ru',
      'Логин может содержать только буквы, цифры, "_" и ".".': 'Username must contain only letters, numbers, underscores and dots.',
      'Указанный логин занят. Пожалуйста, выберете другой.': 'The specified login is busy. Please choose another one.',
      'Активация по указанной ссылке уже была произведена ранее.': 'Account activation using this link has already been made earlier.',
      'Аккаунт успешно активирован.': 'Account successfully activated.',
      'Повторите пароль': 'Repeat password',
      'Пароли не совпадают.': 'Passwords do not match',
      'Регистрируясь в сервисе Platformcraft, вы соглашаетесь с политикой использования': 'By signing up, you agree to our',
      'персональных данных': 'Privacy Policy',
      'Входя в аккаунт Platformcraft, вы соглашаетесь с политикой использования': 'By signing in, you agree to our',
      'Название организации': 'Organization',
      'Обязательное поле.': 'Field is required'
    }
  },
  missing (locale, message, app) {
    // Add initial string as default fallback
    app.$i18n.mergeLocaleMessage(locale, { [message]: message })
    // Re-render component with missing string
    app.$nextTick(() => {
      app.$forceUpdate()
    })
  }
})
